import React, { useEffect, useRef, useState } from "react";
import Styles from "./topBarNew.module.scss";
import { useNavigate } from "react-router-dom";
import { WHITE } from "../colors";
import {
  getUserDisplayEmail,
  getUserDisplayName,
} from "../../utils/authSession";
import { testIdProps } from "../../utils/testIdProps";

interface UserDropdownProps {
  user: Record<string, unknown> | null;
  userDetails?: Record<string, unknown> | null;
  handleLogout: () => void;
  setShowChangePassword: (show: boolean) => void;
}

const UserDropdown: React.FC<UserDropdownProps> = ({
  user,
  userDetails,
  handleLogout,
  setShowChangePassword,
}) => {
  const displayName =
    getUserDisplayName(userDetails) || getUserDisplayName(user);
  const displayEmail = getUserDisplayEmail(userDetails) || getUserDisplayEmail(user);
  const initial = displayName.trim()[0]?.toUpperCase() ?? "";
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    }

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <div
      className="pl-2 pr-3"
      ref={dropdownRef}
      style={{ position: "relative" }}
    >
      <div
        {...testIdProps("avatar-logo")}
        onClick={() => setShowDropdown((prev) => !prev)}
        style={{ cursor: "pointer" }}
      >
        <div
          className={`${Styles.userSectionBackground} d-flex justify-content-center align-items-center`}
        >
          <p className={`mb-0 ${Styles.initial}`}>{initial}</p>
        </div>
      </div>

      {showDropdown && (
        <div
          className="dropdown-menu dropdown-menu-right"
          style={{
            borderRadius: "8px",
            width: "250px",
            backgroundColor: WHITE,
            border: 0,
            boxShadow: "0 3px 10px 0 rgba(0, 0, 0, 0.16)",
            zIndex: 9999,
            display: "block",
            right: 0,
            left: "auto",
            top: "48px",
            position: "absolute",
          }}
          aria-labelledby="dropdownMenuButton"
        >
          <div className="p-3">
            <div className="d-flex align-items-center">
              <div className="px-2">
                <div
                  className={`${Styles.userSectionBackground} d-flex justify-content-center align-items-center`}
                  style={{ cursor: "default" }}
                >
                  <p className={`mb-0 ${Styles.initial}`}>{initial}</p>
                </div>
              </div>
              <div className="px-2 flex-grow-1 min-width-0">
                <p className={`mb-0 ${Styles.userName}`}>{displayName}</p>
                <p className={`mb-0 ${Styles.userEmail}`}>{displayEmail}</p>
              </div>
            </div>
          </div>
          <hr className={Styles.divider} />

          <div
            {...testIdProps("top-bar-new-business-info")}
            onClick={() => {
              setShowDropdown(false);
              navigate("/my-account");
            }}
            className={`p-3 d-flex align-items-center justify-content-center ${Styles.businessInfoBack}`}
          >
            <p className={`mb-0 ${Styles.businessInfo}`}>Business Info</p>
          </div>
          <hr className={Styles.divider} />

          <div
            {...testIdProps("top-bar-new-show-password")}
            onClick={() => {
              setShowDropdown(false);
              setShowChangePassword(true);
            }}
            className={`p-3 d-flex align-items-center justify-content-center ${Styles.changePasswordBack}`}
          >
            <p className={`mb-0 ${Styles.changePassword}`}>Change Password</p>
          </div>
          <hr className={Styles.divider} />

          <div
            {...testIdProps("top-bar-new-logout")}
            onClick={() => {
              setShowDropdown(false);
              handleLogout();
            }}
            className={`p-3 d-flex align-items-center justify-content-center ${Styles.logOutBack}`}
          >
            <p className={`mb-0 ${Styles.logOut}`}>Logout</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
